import { createStore, applyMiddleware, compose} from 'redux'
import  logger  from 'redux-logger'
import thunk from 'redux-thunk'
import reducers from '../reducers'
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
    reducers,composeEnhancers(
        applyMiddleware(thunk,logger)
    )
);
export default store